import api from '../lib/api';
import type { FieldVisitRequest, FieldVisitRequestInput } from '../types/fieldVisit';

// Single-record endpoints return `{ data: { id, type, attributes: T } }`.
// Mirrors sales-log.service.ts. The list, detail and accounts endpoints come
// with the detail page (ENG-751).

export const fieldVisitRequestService = {
  create: async (data: FieldVisitRequestInput): Promise<FieldVisitRequest> => {
    const response = await api.post<{ data: { attributes: FieldVisitRequest } }>(
      '/field_visit_requests',
      { field_visit_request: data },
    );
    return response.data.data.attributes;
  },
};

export default fieldVisitRequestService;
